module.exports = __webpack_public_path__ + "static/media/X.dc0168b0.png";